import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-requisition-create-from',
  templateUrl: './requisition-create-from.component.html',
  styleUrls: ['./requisition-create-from.component.css']
})
export class RequisitionCreateFromComponent implements OnInit {
    stockKeyno;

    public itemsListStocks: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockKeyno = this.stateService.getStateParams()['stock_keyno'];
    }

    private async loadStocks() {
        if (!!this.stockKeyno) {
            this.itemsListStocks = await this.datatask.Post(759, { stock_keyno_to: this.stockKeyno });
        }
    }

    private async init() {
        this.loadStocks();
    }

    ngOnInit() {
        this.init();
    }
}
